<template>
  <el-dialog :visible.sync="visible" :title="tableName+'列设计'" :close-on-click-modal="false"
             :close-on-press-escape="false" width="80%" :append-to-body="true">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('sys:table:save')" type="primary" @click="addOrUpdateHandle()">{{
            $t('add')
          }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('sys:table:delete')" type="danger" @click="deleteHandle()">{{
            $t('deleteBatch')
          }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="label" label="列名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="prop" label="字段名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="width" label="默认列宽" header-align="center" align="center"></el-table-column>
      <el-table-column prop="formatter" label="格式化" header-align="center" align="center"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('sys:table:update')" type="text" size="small"
                     @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
          </el-button>
          <el-button v-if="$hasPermission('sys:table:delete')" type="text" size="small"
                     @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update :table-id="tableId" v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/table/detail/page',
        getDataListIsPage: true,
        deleteURL: '/sys/table/detail',
        deleteIsBatch: true,
        activatedIsNeed: false
      },
      tableId:'',
      tableName:'',
      visible: false,
      dataForm: {
        id: '',
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    init () {
      this.reload()
      this.visible = true
    }
  }
}
</script>
